import type { SecondaryMarketLiveReloadFormFetched } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import type { SecondaryMarketLiveInitFormFetched } from 'state/secondaryMarket/live/live.actions';
import { referentialReducerFactory } from 'state/secondaryMarket/shared/referential/referential.reducer';

export const liveReferentialReducer = referentialReducerFactory<
  'LIVE',
  SecondaryMarketLiveReloadFormFetched | SecondaryMarketLiveInitFormFetched
>('LIVE', (_: SecondaryMarketLiveReloadFormFetched | SecondaryMarketLiveInitFormFetched) => ({}));
